import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './shared/services/user.service';
import { HeaderComponent } from './shared/components-generals/header/header.component';
import { Router } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

const APP_ICONS = [
  'alerta_amarillo',
  'icon_auto',
  'icon_brands',
  'icon_categories',
  'icon_conditions',
  'icon_coverages',
  'icon_deadlines',
  'icon_dealers',
  'icon_personTypes',
  'icon_plans',
  'icon_products',
  'icon_programs',
  'icon_zones',
  'icon_insurances',
  'icon_rates',
  'icon_years',
  'icon_vehicle_uses',
  'icon_models',
  'icon_change_password',
] as const;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal(environment.appName);
  protected isLoggedIn = false;

  constructor(
    private translate: TranslateService,
    private authService: AuthService,
    private iconRegistry: MatIconRegistry,
    private router: Router,
    private sanitizer: DomSanitizer,
    private titleService: Title,
  ) {
    this.titleService.setTitle(environment.appName);
    this.translate.setDefaultLang('es');
    this.translate.use('es');

    this.router.events.subscribe(() => {
      const token = localStorage.getItem('token');
      this.isLoggedIn =
        !!token && this.router.url !== '/login' && this.router.url !== '/external-access';
    });
    this.authService.startPingLoop();

    APP_ICONS.forEach((iconName) => {
      this.iconRegistry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${iconName}.svg`),
      );
    });
  }
}
